import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { Bell } from 'react-feather';
import { LI, UL } from '../../../AbstractElements';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../../Config/api';

const POLL_INTERVAL = 30000;

const authHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

const Notifications = () => {
  const role = (localStorage.getItem('userRole') || '').toLowerCase();
  const isCustomer = role === 'customer';

  const [orders, setOrders] = useState([]);

  const fetchOrders = useCallback(async () => {
    try {
      if (isCustomer) {
        const res = await axios.get(`${API_BASE_URL}/api/customer/orders`, authHeader());
        const all = res.data?.orders || res.data || [];
        setOrders(all.filter(o => o.status === 'Confirmed'));
      } else {
        const res = await axios.get(`${API_BASE_URL}/api/all-orders`);
        const all = res.data?.orders || res.data || [];
        setOrders(all.filter(o => o.status === 'New Order' || !o.status));
      }
    } catch (_) {}
  }, [isCustomer]);

  useEffect(() => {
    fetchOrders();
    const id = setInterval(fetchOrders, POLL_INTERVAL);
    return () => clearInterval(id);
  }, [fetchOrders]);

  const count = orders.length;
  const title = isCustomer ? 'Confirmed Orders' : 'New Orders';
  const emptyMsg = isCustomer ? 'No confirmed orders' : 'No new orders';
  const linkTo = isCustomer
    ? `${process.env.PUBLIC_URL}/customer/orders`
    : `${process.env.PUBLIC_URL}/faraadmin/all-orders`;

  return (
    <Fragment>
      <LI attrLI={{ className: 'onhover-dropdown' }}>
        <div className="notification-box" style={{ position: 'relative', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}>
          <Bell size={20} />
          {count > 0 && (
            <span className="badge rounded-pill badge-primary" style={{ position: 'absolute', top: '-7px', right: '-7px', fontSize: '6px', minWidth: '14px', height: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: '1', padding: '0 3px' }}>
              {count}
            </span>
          )}
        </div>
        <UL attrUL={{ className: 'simple-list notification-dropdown onhover-show-div' }}>
          <LI>
            <div className="d-flex align-items-center gap-2 p-1">
              <Bell size={18} />
              <strong>{title}</strong>
            </div>
          </LI>
          {count === 0 ? (
            <LI>
              <p className="text-muted mb-0 px-2 py-1" style={{ fontSize: '13px' }}>{emptyMsg}</p>
            </LI>
          ) : (
            orders.slice(0, 10).map((order) => (
              <LI key={order.order_id}>
                <Link to={linkTo} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <p className="mb-0" style={{ fontSize: '13px' }}>
                    <i className="fa fa-circle-o me-2 font-primary"></i>
                    <strong>{order.order_id}</strong> — {order.store_name || order.status}
                    {order.order_date && (
                      <span className="pull-right text-muted" style={{ fontSize: '11px' }}>
                        {new Date(order.order_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}
                      </span>
                    )}
                  </p>
                </Link>
              </LI>
            ))
          )}
          <LI>
            <Link to={linkTo} className="btn btn-primary btn-sm w-100">
              {isCustomer ? 'View My Orders' : 'View All Orders'}
            </Link>
          </LI>
        </UL>
      </LI>
    </Fragment>
  );
};

export default Notifications;
